import { i18next } from '@yola/ws-sdk';
import isMedia from './is-media';

// label determination procedure
// 1. if target element is media container from specific blocks - return 'Media'
// 1. otherwise - return empty string
const getCaptionForTriggerLabel = (element) => {
  if (isMedia(element)) {
    return i18next.t('Media');
  }

  return '';
};

export default getCaptionForTriggerLabel;
